import { PlusOutlined } from "@ant-design/icons"
import { Card, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

const { Text } = Typography

interface CreateAlbumCardProps {
  onClick?: () => void
}

export function CreateAlbumCard({ onClick }: CreateAlbumCardProps) {
  const { t } = useTranslation()

  return (
    <Card
      hoverable
      onClick={onClick}
      className="h-full border-dashed cursor-pointer"
      styles={{
        body: {
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center"
        }
      }}
    >
      <div className="size-10 rounded-full bg-primary/10 flex items-center justify-center mb-3">
        <PlusOutlined className="text-lg text-primary" />
      </div>
      <Text strong className="block mb-1">
        {t("files.albums.createCard.title")}
      </Text>
      <Text type="secondary" className="text-sm px-2">
        {t("files.albums.createCard.description")}
      </Text>
    </Card>
  )
}
